module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-flex', [_vm._l((_vm.returnItem), function(val, key) {
    return _c('v-text-field', {
      key: key,
      attrs: {
        "label": key,
        "value": val,
        "readonly": ""
      }
    })
  }), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.getPdf(_vm.returnItem.downloadPath)
      }
    }
  }, [_vm._v("get pdf")])], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /export/jenkins/workspace/prod-isrs-frontend-mb_master/~/vue-loader/lib/template-compiler?{"id":"data-v-59b91cb5"}!/export/jenkins/workspace/prod-isrs-frontend-mb_master/~/vue-loader/lib/selector.js?type=template&index=0!./client/views/GetReturn.vue
// module id = 938
// module chunks = 1